<template>
  <vue-flashcard
    front="WAREHOUSE MANAGEMENT SYSTEM (JAVA)"
    back="Warehouse Management System is made to keep track of inventory items. 
    The system allows user to register new item and check in/out item to track location of item with real-time date stamp and 
    displays entire list of items and appropriate data."
    headerFront=''
    headerBack=''
    footerFront=''
    footerBack=''>
  </vue-flashcard>
</template>

<script>
import vueFlashcard from 'vue-flashcard';

export default {
  components : {
    vueFlashcard,
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Warehouse.vue